import { CellValue } from "exceljs";
import { getClientDomain } from "../../utils/functions/client-code";

export interface SpreadsheetRow {
  [key: string]: CellValue;
}

interface SpreadSheetViewerProps {
  headers: string[];
  data: SpreadsheetRow[];
}

const SpreadSheetViewer = ({ headers, data }: SpreadSheetViewerProps) => {
  const clientCode = getClientDomain();
  return (
    <div className="flex-1">
      <div className="overflow-auto slim-scrollbar max-h-[60vh] pb-2">
        <table
          className="w-full border-collapse"
          style={{ minWidth: "max-content" }}
        >
          <thead>
            <tr className="sticky top-0 z-20 bg-ternary-gray">
              {headers?.map((header, idx) => (
                <th
                  key={idx}
                  className="px-4 py-2 !text-base text-left !font-medium !text-primary-black-dk whitespace-nowrap border-r border-black/10 last:border-r-0"
                  style={{ minWidth: "150px" }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row, rowIndex) => (
              <tr key={rowIndex} className="border-b border-black/10">
                {headers?.map((header, colIndex) => (
                  <td
                    key={colIndex}
                    className="px-4 py-2 !text-sm text-left !font-normal !text-primary-blue-dk whitespace-nowrap bg-white border-r border-black/10 last:border-r-0"
                    style={{ minWidth: "150px" }}
                  >
                    {header === "name" && row.lead_id ? (
                      <a
                        // href={`/${clientCode}/dashboard/crm/${row.lead_id?.toString() || ""}`}
                        href={`/dashboard/crm/${
                          row.lead_id?.toString() || ""
                        }?client_code=${clientCode}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:text-blue-dk hover:underline cursor-pointer"
                      >
                        {row[header]?.toString() || ""}
                      </a>
                    ) : (
                      row[header]?.toString() || ""
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SpreadSheetViewer;
